<template>
	<span class="me-2">
		<svg
			width="18"
			height="18"
			viewBox="0 0 18 18"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M9.12332 13.5081C11.133 13.5081 12.7621 11.6551 12.7621 9.36926C12.7621 7.08344 11.133 5.23041 9.12332 5.23041C7.11365 5.23041 5.4845 7.08344 5.4845 9.36926C5.4845 11.6551 7.11365 13.5081 9.12332 13.5081Z"
				stroke="#585F66"
				stroke-width="1.5"
				stroke-miterlimit="10"
			/>
			<path
				d="M13.0114 6.08716H5.14219C4.88666 6.08716 4.6795 6.29431 4.6795 6.54984V8.00416C4.6795 8.2597 4.88666 8.46685 5.14219 8.46685H13.0114C13.267 8.46685 13.4741 8.2597 13.4741 8.00416V6.54984C13.4741 6.29431 13.267 6.08716 13.0114 6.08716Z"
				fill="#585F66"
				stroke="#585F66"
				stroke-width="1.5"
				stroke-miterlimit="10"
			/>
			<path
				d="M11.0994 3.77734C11.8939 3.77734 12.538 3.13323 12.538 2.33868C12.538 1.54413 11.8939 0.900024 11.0994 0.900024C10.3048 0.900024 9.66071 1.54413 9.66071 2.33868C9.66071 3.13323 10.3048 3.77734 11.0994 3.77734Z"
				fill="#585F66"
				stroke="#585F66"
				stroke-width="1.5"
				stroke-miterlimit="10"
			/>
			<path
				d="M7.7702 6.198V8.08006"
				stroke="#585F66"
				stroke-width="1.5"
				stroke-miterlimit="10"
			/>
			<path
				d="M12.7622 7.13904C12.6285 5.23408 12.0127 3.99905 10.1729 3.77855C8.37754 3.56287 5.98942 5.12925 5.39178 7.13904H12.7622Z"
				fill="#585F66"
				stroke="#585F66"
				stroke-width="1.5"
				stroke-miterlimit="10"
			/>
			<path
				d="M14.5839 17.1C13.6597 14.983 11.55 13.5034 9.09194 13.5034C6.63514 13.5034 4.52414 14.983 3.59998 17.1H14.5839Z"
				fill="#585F66"
				stroke="#585F66"
				stroke-width="1.5"
				stroke-linejoin="round"
			/>
		</svg>
	</span>
</template>

<script>
export default {
	name: "ParticipantIcon",
	props: {},
	computed: {},
};
</script>
